/**
 * Who made a grant, when no member of staff did.
 *
 * A grant with no granter is one of two things: auth made it itself (a store
 * tester's test purchase, auth#578), or the member of staff who made it has
 * since deleted their account. Only `grantSource` tells them apart; it is null
 * on every staff grant. An auth older than auth#643 does not send it, which
 * reads as null too, so the portal falls back to the old label.
 */
const AUTOMATIC: Record<string, string> = {
  'tester-purchase': 'Automatic (store tester)',
};

/** The label for an automatic grant, or null when a person made it. */
export function automaticGrantLabel(source: string | null | undefined): string | null {
  if (!source) return null;
  return AUTOMATIC[source] ?? 'Automatic';
}

/** The "Granted by" text for a grant whose granter is not a person on file. */
export function missingGranterLabel(source: string | null | undefined): string {
  return automaticGrantLabel(source) ?? 'A deleted account';
}
